module.exports = __webpack_public_path__ + "static/network-map-ebd08b6ac2687b0369e2f8b177b06259.svg";